import axios from '../jslib/http'
import {request} from "../jslib/request";
const BASE_REQUEST = '/oa/contractCase'

export function getContractCase(pageNo,pageSize,contractType,jiayifang,voyagenumber,status){
    const url = `${BASE_REQUEST}/getContractCaseByPage`
    var data = {
        pageNo:pageNo,
        pageSize:pageSize,
        contractType:contractType,
        jiayifang:jiayifang,
        voyageNumber:voyagenumber,
        status:status
    }
    return axios
    .get(url,{
        params:data
    })
    .then(res => {
        if (res !== undefined) {
            return res.data
        } else {
            return res
        }
    })
}

export function getCaseMongoData(contractMongoId){
    const url =`${BASE_REQUEST}/getCaseMongoData`
    var data = {
        contractMongoId:contractMongoId
    }
    return axios
        .get(url,{
            params:data
        })
        .then(res => {
            if (res !== undefined) {
                return res.data
            } else {
                return res
            }
        })
}


export function changeContractCaseStatus(processInstanceId,contractId){
    const url =`${BASE_REQUEST}/changeContractCaseStatus`
    var data = {
        processInstanceId:processInstanceId,
        contractId:contractId
    }
    return axios
        .get(url,{
            params:data
        })
        .then(res => {

        })
}

export function getCustomerNameList(shipLineID){
    const url = `${BASE_REQUEST}/getCustomerNameList`
    var data={
        shipLineID:shipLineID
    }
    return axios
    .get(url,{
        params:data
    })
    .then(res => {
        if (res !== undefined) {
            return res.data
        } else {
            return res
        }
    })
}

export function getShipOwnerList(shipLineID){
    const url = `${BASE_REQUEST}/getShipOwnerList`
    var data={
        shipLineID:shipLineID
    }
    return axios
    .get(url,{
        params:data
    })
    .then(res => {
        if (res !== undefined) {
            return res.data
        } else {
            return res
        }
    })
}
export function saveUploadContract(shiplineid,jiafangid,url,jiafangname,sourceid,lidlist) {
  return request({
    url:`${BASE_REQUEST}/saveUploadContract`,
    data:{
      shiplineid:shiplineid,
      jiafangid: jiafangid,
      url: url,
      jiafangname:jiafangname,
      sourceid:sourceid,
      lidlist:lidlist,
    }
  })
}
export function getContractCaseByid(id) {
  return request({
    url:`${BASE_REQUEST}/getContractCaseByid`,
    data:{
      id:id
    }
  })
}
export function updateContractCase(obj) {
  return request({
    url:`${BASE_REQUEST}/updateContractCase`,
    data:obj
  })
}
export function saveUploadContractByInfo(info) {
  return request({
    url:`${BASE_REQUEST}/saveUploadContract`,
    data:info
  })
}
